// extracted by mini-css-extract-plugin
module.exports = {"action-link":"style_action-link__3grd3","total-font":"style_total-font__pRmPW"};